import { RULE_ACTION } from '@/consts.js';
import { getRuleIcon } from '@/utils/rule.js';

// Accent colors of the automation types (8ad $primary-color / $pink / $orange).
// Full class names, so Tailwind finds them. The hover glow sets the glass
// tile's --tile-glow layer, so the box-shadow fades instead of jumping.
export const GLOW_TRANSITION = 'transition-shadow duration-300 ease-in-out';
const STYLES = {
  [RULE_ACTION.START]: {
    tone: 'primary',
    checkbox: 'data-[state=checked]:border-primary data-[state=checked]:bg-primary',
    bg: 'bg-primary',
    text: 'text-primary',
    border: 'border-primary',
    glow: 'hover:[--tile-glow:color-mix(in_oklab,var(--primary)_40%,transparent)]',
    chip: 'border-primary bg-primary/10',
  },
  [RULE_ACTION.SCALING_UP]: {
    tone: 'pink',
    checkbox: 'data-[state=checked]:border-[#FE02BB] data-[state=checked]:bg-[#FE02BB]',
    bg: 'bg-[#FE02BB]',
    text: 'text-[#FE02BB]',
    border: 'border-[#FE02BB]',
    glow: 'hover:[--tile-glow:rgb(254_2_187/0.4)]',
    chip: 'border-[#FE02BB] bg-[#FE02BB]/10',
  },
  [RULE_ACTION.STOP]: {
    tone: 'orange',
    checkbox: 'data-[state=checked]:border-[#FE7002] data-[state=checked]:bg-[#FE7002]',
    bg: 'bg-[#FE7002]',
    text: 'text-[#FE7002]',
    border: 'border-[#FE7002]',
    glow: 'hover:[--tile-glow:rgb(254_112_2/0.4)]',
    chip: 'border-[#FE7002] bg-[#FE7002]/10',
  },
};

/** Colors and icon class (src/assets/icons.css) of an automation type (rule action). */
export function ruleActionStyle(action) {
  return {
    ...(STYLES[action] || STYLES[RULE_ACTION.STOP]),
    icon: getRuleIcon(action),
  };
}
